import { API } from "@/utils/api";

/* Create stripe checkout session */
export const subscribe = async (payload: {
  plan: string;
  couponCode: string;
}) => {
  const response = await API().post(`/subscribe`, payload);
  return response.data.data;
};

export const unsubscribe = async () => {
  const response = await API().post(`/unsubscribe`);
  return response.data.data.user;
};

/* Get Stripe coupon */
export const getCoupon = async (code: string) => {
  const response = await API().get(`/coupon?couponcode=${code}`);
  return response.data.data.coupon;
};
